let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g5LV7")).then(() => parcelRequire('88szQ'));